<div class="customSnackbar" id="div-snack" [ngClass]="{ 'block': !options?.absolutePosition }">
  {{content}}
  <span class="close-btn" (click)="closeSnack()">&#10005;</span>
</div>
